export function cases() {
    function loadMore() {
        const formData  = new FormData();
        const $hashItem = document.querySelector('.js-hashItem.active');

        if ($hashItem !== null) {
            formData.append('hashtag_id', $hashItem.dataset.id);
        }

        document.querySelectorAll('.js-card').forEach($item => formData.append('exclude_ids[]', $item.dataset.id));

        fetch(location.href, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
        .then(response => response.json())
        .then(r => {
            const $cards    = document.querySelector('.js-cards');
            const $loadMore = document.querySelector('.js-loadMore');

            if (r.status === 'ok') {
                $cards.innerHTML += r.render;

                $loadMore.classList.toggle('is-hidden', r.count <= $loadMore.dataset.limit);
            }
        });
    }

    function hashFilter($hashtag_id) {
        const formData = new FormData();
              formData.append('hashtag_id', $hashtag_id);

        fetch(location.href, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
        .then(response => response.json())
        .then(r => {
            const $cards    = document.querySelector('.js-cards');
            const $loadMore = document.querySelector('.js-loadMore');

            if (r.status === 'ok') {
                $cards.innerHTML = r.render;

                $loadMore.classList.toggle('is-hidden', r.count <= 6);
            }
        });
    }

    function hashClick($item) {
        document.querySelectorAll('.js-hashList .js-hashItem').forEach($hash => $hash.classList.remove('active'));
        $item.classList.add('active');

        hashFilter($item.dataset.id);
    }

    document.addEventListener('click', function(e) {
        const $item = e.target;

        if ($item.classList.contains('js-hashItem')) {
            return hashClick($item);
        }

        if ($item.classList.contains('js-loadMore')) {
            return loadMore();
        }
    });
}
